"use client";

import type { Participant } from "./base-session-template";
import { ActivityDisplayPreview } from "./previews";

export type RideType =
  | "easy"
  | "training"
  | "interval"
  | "long"
  | "race"
  | "commute";

export type CyclingTemplateData = {
  rideType: RideType;
  distance: number; // km
  time: { hours?: number; minutes: number; seconds: number };
  avgSpeedKmh?: number;
};

export type CyclingParticipant = Participant;

type CyclingDisplayProps = {
  data: CyclingTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function CyclingDisplay({ data, participants }: CyclingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="cycling"
      data={data}
      participants={participants}
    />
  );
}
